export default __webpack_public_path__ + "static/about-portraits-bdecda3e31425ce65220c731d77e8b58.png";